import { IDisciplineSelection } from '../types'

/**
 * Calculates the base weight for a single discipline
 * Formula: relevance * 2^(5 - knowledge)
 */
export const calculateBaseWeight = (knowledgeLevel: number, relevanceLevel: number): number => {
  const knowledge = Math.max(0, knowledgeLevel)
  const relevance = Math.max(1, relevanceLevel)

  return relevance * Math.pow(2, 5 - knowledge)
}

/**
 * Calculates the accumulated weight for all selected disciplines
 */
export const calculateAccumulatedWeight = (disciplines: IDisciplineSelection[]): number => {
  return disciplines
    .filter((d) => d.isSelected)
    .reduce((acc, discipline) => {
      return acc + calculateBaseWeight(discipline.knowledgeLevel, discipline.relevanceLevel)
    }, 0)
}

/**
 * Calculates the normalized weight percentage for a single discipline
 * Returns a value between 0-100 representing the percentage
 */
export const calculateNormalizedWeight = (
  discipline: IDisciplineSelection,
  accumulatedWeight: number
): number => {
  if (!discipline.isSelected) {
    return 0
  }

  const baseWeight = calculateBaseWeight(discipline.knowledgeLevel, discipline.relevanceLevel)
  const normalizedWeight = (baseWeight / (accumulatedWeight || 1)) * 100

  return Math.round(normalizedWeight)
}

/**
 * Calculates weights for all disciplines in a list
 * Returns a new array with updated weight values
 */
export const calculateAllWeights = (
  disciplines: IDisciplineSelection[]
): IDisciplineSelection[] => {
  const accumulatedWeight = calculateAccumulatedWeight(disciplines)

  return disciplines.map((discipline) => ({
    ...discipline,
    weight: calculateNormalizedWeight(discipline, accumulatedWeight),
  }))
}
